var map = {
	"./avatar-aica.png": "2dfb",
	"./avatar-centrum-riviera.png": "a5cf",
	"./avatar-galeria-pomorska.png": "9b2f",
	"./avatar-galeria-posnania.png": "b220",
	"./avatar-hotel-bialy-kamien.png": "0e25",
	"./avatar-leaf.png": "844c",
	"./avatar-pasaz-grunwaldzki.svg": "f6d0",
	"./avatar-posnania-action.png": "9e6f",
	"./avatar-posnania-valentines.png": "5141",
	"./avatar-valo-motion.png": "6299",
	"./avatar.png": "bb20",
	"./logo-baltycka.png": "390c",
	"./santa-claus.png": "8a30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8085";